import { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './Gallery_fullscreen_modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinimize } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode, Navigation, Thumbs } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { IDS } from '../../../../utils/IDS';

const Gallery_fullscreen_modal = (props) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [mainSwiper, setMainSwiper] = useState(null);

    const sliderdata = [
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },
        { img: '/assets/images/gallery/gal1.png' },
        { img: '/assets/images/gallery/gal2.png' },
        { img: '/assets/images/gallery/gal3.png' },

    ]

    const isVideo = (fileName) =>
        /\.(mp4|webm|ogg|mov|avi)$/i.test(fileName);
    const frames = props?.frames || [];
    const initialSlideIndex = props?.initialSlideIndex >= 0 ? props?.initialSlideIndex : 0;

    return (
        <>
            <Modal
                {...props}
                fullscreen
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='Gallery_fullscreen_modal'
            >
                <div className='container'>
                    <Modal.Header  >
                        <FontAwesomeIcon className='minimizeicon' icon={faMinimize} onClick={props.onHide} />
                    </Modal.Header>
                    <Modal.Body>
                        <div className='slider_sec'>
                            <div className='row'>
                                <div className='col-md-6 mx-auto'>
                                    <Swiper
                                        onSwiper={setMainSwiper}
                                        style={{
                                            '--swiper-navigation-color': '#fff',
                                            '--swiper-pagination-color': '#fff',
                                        }}
                                        loop={true}
                                        spaceBetween={10}
                                        navigation={true}
                                        initialSlide={initialSlideIndex}
                                        thumbs={{
                                            swiper: thumbsSwiper && !thumbsSwiper.destroyed
                                                ? thumbsSwiper
                                                : null
                                        }}
                                        autoplay={{
                                            delay: 2000,
                                            disableOnInteraction: false,
                                        }}
                                        modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                                        className="main_box"
                                    >
                                        {frames.map((data, index) => (
                                            <SwiperSlide key={data.id || index}>
                                                <div className='slide_div'>
                                                    {isVideo(data?.name) ? (
                                                        <video
                                                            className='slide_img'
                                                            src={IDS.IMG_URL + data.name}
                                                            muted
                                                            playsInline
                                                            preload="metadata"
                                                            style={{ objectFit: "cover", pointerEvents: "none" }}
                                                        />
                                                    ) : (
                                                        <img
                                                            className='slide_img'
                                                            src={IDS.IMG_URL + data.name}
                                                            alt="slide-img"
                                                            style={{ objectFit: "cover" }}
                                                        />
                                                    )}
                                                </div>
                                            </SwiperSlide>
                                        ))}

                                    </Swiper>
                                </div>
                            </div>

                            <Swiper
                                onSwiper={setThumbsSwiper}
                                loop={true}
                                spaceBetween={10}
                                slidesPerView={10}
                                freeMode={true}
                                watchSlidesProgress={true}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }}
                                modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                                className="sub_images"
                                breakpoints={{
                                    0: {
                                        slidesPerView: 5,
                                        spaceBetween: 5,
                                    },
                                    350: {
                                        slidesPerView: 8,
                                        spaceBetween: 5,
                                    },
                                    575: {
                                        slidesPerView: 10,
                                        spaceBetween: 10,
                                    },
                                    991: {
                                        slidesPerView: 14,
                                        spaceBetween: 10,
                                    },
                                }}
                            >
                                {frames.map((data, index) => (
                                    <SwiperSlide key={data.id || index}>
                                        <div className='slide_div'>
                                            {isVideo(data?.name) ? (
                                                <video
                                                    className='slide_img'
                                                    src={IDS.IMG_URL + data.name}
                                                    muted
                                                    playsInline
                                                    preload="metadata"
                                                    style={{ objectFit: "cover", pointerEvents: "none" }}
                                                />
                                            ) : (
                                                <img
                                                    className='slide_img'
                                                    src={IDS.IMG_URL + data.name}
                                                    alt="slide-img"
                                                    style={{ objectFit: "cover" }}
                                                />
                                            )}
                                        </div>
                                    </SwiperSlide>
                                ))}


                            </Swiper>
                        </div>
                    </Modal.Body>

                </div>
            </Modal>
        </>
    );
}

export default Gallery_fullscreen_modal;
